var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7323 22C5.22147 22 4.7891 21.8261 4.43518 21.4782C4.08126 21.1303 3.9043 20.7053 3.9043 20.2031V6.89935C3.9043 6.39723 4.08126 5.97222 4.43518 5.62433C4.7891 5.27644 5.22147 5.1025 5.7323 5.1025H7.13231V3H8.68805V5.1025H16.3499V3H17.8668V5.1025H19.2668C19.7776 5.1025 20.21 5.27644 20.5639 5.62433C20.9178 5.97222 21.0948 6.39723 21.0948 6.89935V20.2031C21.0948 20.7053 20.9178 21.1303 20.5639 21.4782C20.21 21.8261 19.7776 22 19.2668 22H5.7323ZM5.7323 20.509H19.2668C19.3446 20.509 19.4159 20.4772 19.4806 20.4134C19.5455 20.3498 19.578 20.2797 19.578 20.2031V10.8752H5.4211V20.2031C5.4211 20.2797 5.45355 20.3498 5.51843 20.4134C5.58315 20.4772 5.65444 20.509 5.7323 20.509ZM5.4211 9.38427H19.578V6.89935C19.578 6.82281 19.5455 6.75274 19.4806 6.68912C19.4159 6.62534 19.3446 6.59345 19.2668 6.59345H5.7323C5.65444 6.59345 5.58315 6.62534 5.51843 6.68912C5.45355 6.75274 5.4211 6.82281 5.4211 6.89935V9.38427Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.923bba6c6c81743933b59d5a3bda78f7.svg";
export { ForwardRef as ReactComponent };